'use strict';

/**
 * @ngdoc directive
 * @name courseApp.directive:selcourseheader
 * @description
 * # selcourseheader
 */
angular.module('courseApp')
    .directive('selcourseheader', function () {
        return {
            templateUrl: 'views/directives/selcourseheader.html',
            transclude: true,
            // restrict: 'E'
            restrict: 'EA',
            scope: {
                selectedcourse: '='
            }
        };
    });
